export class StringUtil {
  static compareWithLocalStrings = (a, b) =>
    !!a
      .split('')
      .filter((v, i) => a.slice(i, b.length).localeCompare(b, 'en', { sensitivity: 'base' }) === 0)
      .length;
}